import { useState } from "react";
import { DownloadOutlined, ReloadOutlined, SettingOutlined } from "@ant-design/icons";
import { useQuery } from "@tanstack/react-query";
import { Button, Card, Space, Typography } from "antd";
import { Navigate } from "react-router-dom";
import { useFlags, useFeaturesListQuery } from "@/shared/lib/flags";
import { routes } from "@/shared/lib/react-router";
import { projectQueries } from "@entities/project";
import { useCoordinator } from "@shared/lib/hooks";
import { useActsRegistry, useFilterState, usePagination, useSortState } from "../../model";
import { RegistryFilters, RegistryPagination, RegistryTable } from "./ui";
import "./records-register-page.scss";

const { Title } = Typography;

export function RecordsRegisterPage() {
  const { isLoading: isFlagsLoading } = useFeaturesListQuery();
  const isActsRegistryEnabled = useFlags("actsRegistryEnabled");

  const { projectId, isLegacyProject } = useCoordinator();
  const [showExtraFilters, setShowExtraFilters] = useState(false);

  const { data: project } = useQuery(
    projectQueries.getProject({
      projectId,
      idType: isLegacyProject ? "externalId" : "projectId",
    }),
  );

  const pagination = usePagination();
  const filterState = useFilterState();
  const sort = useSortState();

  const { rows, total, isLoading, refetch } = useActsRegistry({
    projectExternalId: project?.externalId ?? "",
    page: pagination.page,
    limit: pagination.limit,
    sortField: sort.sortField,
    sortDirection: sort.sortDirection,
  });

  if (!isFlagsLoading && !isActsRegistryEnabled) {
    return <Navigate to={routes.page_not_found()} replace />;
  }

  return (
    <div className="general-view-container records-register-page__viewport">
      <div className="records-register-page__root">
        <div className="records-register-page__top">
          <Title level={4} className="records-register-page__title">
            Реестр актов ({total})
          </Title>
          <Space size={8} className="records-register-page__actions">
            <button
              type="button"
              className="records-register-page__icon-action"
              aria-label="Настройки"
              onClick={() => {}}
            >
              <SettingOutlined />
            </button>
            <Button icon={<ReloadOutlined />} onClick={() => refetch()}>Обновить</Button>
            <Button icon={<DownloadOutlined />}>Скачать в .xls</Button>
          </Space>
        </div>

        <Card className="records-register-page__card">
          <RegistryFilters
            filterState={filterState}
            showExtra={showExtraFilters}
            onToggleExtra={() => setShowExtraFilters((prev) => !prev)}
          />
          <div className="records-register-page__table-host">
            <RegistryTable
              data={rows}
              isLoading={isLoading}
              sortDirection={sort.sortDirection}
              onSortChange={sort.onSort}
            />
          </div>
          <RegistryPagination pagination={pagination} total={total} />
        </Card>
      </div>
    </div>
  );
}
